import {
  API_ENDPOINT,
  useClientApiV1AuthChangeEmailVerificationCreateMutation,
} from '../../resources/@types/accountSchema';

function useClientAuthChangeEmailVerificationCreateMutation(
  options?: Parameters<
    typeof useClientApiV1AuthChangeEmailVerificationCreateMutation
  >[0]['options'],
) {
  return useClientApiV1AuthChangeEmailVerificationCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_AUTH_CHANGE_EMAIL_VERIFICATION,
    options,
  });
}

export default useClientAuthChangeEmailVerificationCreateMutation;
